import { connect } from 'react-redux'
import { POPUP_SCREENS } from '../../redux/constants'
import SettingsMenu from './SettingsMenu'
import BetPopup from './BetPopup'
import AutoPlayMenu from '../controls/autoplay/menu'

const PopupScreens = props => {
  const { SETTINGS_MENU, BET, AUTOPLAY } = POPUP_SCREENS
  const {
    dimensions,
    popupScreen,
    svgIcons,
    formatStyle,
  } = props
  const { gamecontrolScale, desktopUI, width, height } = dimensions
  const smartLandscapeWidthCoef = 0.4

  let content
  switch (popupScreen) {
    case SETTINGS_MENU: {
      content = <SettingsMenu svgIcons={svgIcons} />
      break
    }
    case BET: {
      content = <BetPopup
        svgIcons={svgIcons}
        formatStyle={formatStyle}
        smartLandscapeWidthCoef={smartLandscapeWidthCoef}
      />
      break
    }
    case AUTOPLAY: {
      content = <AutoPlayMenu
        svgIcons={svgIcons}
        smartLandscapeWidthCoef={smartLandscapeWidthCoef}
      />
      break
    }
    default: {
      content = null
      break
    }
  }

  const controlScale = desktopUI ? { transform: `scale(${gamecontrolScale})` } : {}
  const controlHeight = desktopUI ? {} : { height }
  const popupSettingsProps = {
    className: 'popup-settings',
    style: { width: width + (desktopUI ? 0 : 2), ...controlScale, ...controlHeight }
  }

  return (
    <div className="popup-settings-wrapper">
      <div {...popupSettingsProps}>
        {content}
      </div>
    </div>
  )
}

export default connect(state => ({
  dimensions: state.UI.dimensions,
  popupScreen: state.UI.popupScreen,
}))(PopupScreens)